import { render, staticRenderFns } from "./Dozentenbuchung.vue?vue&type=template&id=4b99f202&"
import script from "./Dozentenbuchung.vue?vue&type=script&lang=js&"
export * from "./Dozentenbuchung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports